global.modules.set({
  async init(context) {
    $('.tablinks', context).each(function() {
      $(this).find('.tablink:first').addClass('active');
    })
    $('.tabs', context).each(function() {
      $(this).find('.tabcontent:first').addClass('active').attr('hidden', false);
      $(this).find(".tabcontent:not(:first)").removeClass('active').attr('hidden', true);
    })  
    $('.tablink', context).on('click', function () {
      var tablink = $(this);
      var tab_id = tablink.attr('tab_id');
      var tab = $('.tabcontent[tab_id="' + tab_id + '"]').addClass('active').attr('hidden', false);
      tab.closest('.tabs').find('.tabcontent[tab_id!="' + tab_id + '"]').removeClass('active').attr('hidden', true);
      tablink.closest('.tablinks').find('.tablink.active').removeClass('active');
      tablink.addClass('active');
    })
  }
})